import React, { ReactNode } from 'react';
import './style.scss';
import { Result } from 'antd';
import Container from '../container.component';
import { ResultStatusType } from 'antd/es/result';

type NotFoundProps = {
  title: string;
  status: ResultStatusType;
  subTitle: string;
  child?: ReactNode;
};

const NotFound: React.FC<NotFoundProps> = ({ title, subTitle, child, status }) => {
  return (
    <Container>
      <Result status={status} title={title} subTitle={subTitle} extra={child} />
    </Container>
  );
};
export default NotFound;
